const editAssignment = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isEditing: true,
      };
    case 'success':
      return {
        ...state,
        isEditing: false,
      };
    case 'error':
      return {
        ...state,
        isEditing: false,
        assignmentUpdateError: action.payload.assignmentUpdateError,
      };
    default:
      return state;
  }
};

export default editAssignment;
